import styled from 'styled-components';
import { Map } from 'app/components/Map/Map';

export const StyledMachineMap = styled(Map)`
  height: 100%;
`;
